import Vue from 'vue'
import { AbilityBuilder, RawRule } from '@casl/ability'
import { computed, ref } from '@vue/composition-api'
import { AbilityAction, AbilitySubject } from './abilitiesByRole'
import { abilitiesPlugin } from '@casl/vue'

function subjectName (item: string) {
  if (!item || typeof item === 'string') {
    return item
  }
  // @ts-ignore
  return item.__type
}

const ability = AbilityBuilder.define({ subjectName }, () => {
  // can(['read', 'create'], 'Todo')
  // can(['update', 'delete'], 'Todo', { assignee: 'me' })


})

const updateCount = ref(1)

const can = computed(() => {
  if (updateCount.value === 0) {
    return (_action: AbilityAction, _subject: AbilitySubject) => false
  }
  return (action: AbilityAction, subject: AbilitySubject) => ability.can(action, subject)
})


const updateAbilities = (rules: RawRule[]) => {
  ability.update(rules)
  updateCount.value++
}


const setupVueEnv = () => {
  Vue.use(abilitiesPlugin, ability)
}

export { can, updateAbilities, setupVueEnv }
